import BaseComponent from '../abstracts/BaseComponent';
import { DataLayerUtils } from '../utilities/DataLayer';

export default class ProductTileComponent extends BaseComponent {
  constructor(element) {
    super(element);
    this.handleChoose(); 
  }

  handleChoose() {
    var prova = document.getElementsByClassName('recommendations');
    this.$on('click.tile', (e) => {
      if (prova.length) { 
        DataLayerUtils.push({
          'event': 'productClick',
          'ecommerce': {
            'click': {
              'actionField': {
                'list': 'complete_your_look'
              },
              'products': [{
                name: this.$options.name || null,
                id: this.$options.master || null,
                price: this.$options.price || null,
                brand: 'twinset',
                category: this.$options.category || null,
                variant: this.$options.variant || null,
                position: this.$options.position || null
              }]
            }
          }
        });
      } else { 
        DataLayerUtils.push({
          event: 'productClick',
          ecommerce: {
            click: {
              actionField: {
                list: window.dataLayer[0].pageType
              },
              products: [{
                name: this.$options.name || null,
                id: this.$options.master || null,
                price: this.$options.price || null,
                brand: 'pdb',
                category: this.$options.category || null,
                variant: this.$options.variant || null,
                quantity: this.$options.quantity || null,
                dimension14: this.$options.store || null,
                dimension15: this.$options.sales || null,
                dimension16: this.$options.availability || null,
                dimension17: this.$options.sizepercentage || null,
                dimension18: this.$options.discount || null,
                position: this.$options.position || null
              }]
            }
          }
        });
      }
    });
  }
}
